import { GameWrapper } from '@repo/core-phaser-wrapper';
import { StatePlugin } from '@repo/plugin-state';
import { SignalsPlugin } from '@repo/plugin-signals';
import { SplashScene, PreloaderScene } from '@repo/scene-preloader';
import { TimeTrackerPlugin } from '@repo/plugin-timetracker';
import { GameScene } from './scenes/GameScene';

/**
 * Tic-Tac-Logic Game (Binairo/Takuzu)
 *
 * A logic puzzle game where you fill a grid with X's and O's following three rules:
 * 1. No more than two consecutive X's or O's in any row/column
 * 2. Each row/column must have equal numbers of X's and O's
 * 3. All rows must be unique, all columns must be unique
 */

// Create game wrapper with feature flags
const wrapper = new GameWrapper(
  // Game-specific scenes
  [GameScene],

  // Game configuration
  {
    width: 900,
    height: 750,
    backgroundColor: 'transparent',
    parent: 'game-container',
    debug: false,
  },

  // Feature flags
  {
    splash: true,
    preloader: true,
    highscore: false,
    raffle: false,
    api: false,
    analytics: false,
    pauseOnLostFocus: true,
  },

  // Dependencies
  {
    StatePlugin,
    SignalsPlugin,
    SplashScene,
    PreloaderScene,
    TimeTrackerPlugin,
  }
);

// Initialize the game
const game = wrapper.initialize();

// Configure game registry
game.registry.set('firstGameScene', 'GameScene');
game.registry.set('gameName', 'Tic-Tac-Logic');
game.registry.set('assetManifest', {
  images: [],
  spritesheets: [],
  audio: [],
  json: [],
});

// Export for debugging
(window as unknown as { game: Phaser.Game }).game = game;
(window as unknown as { wrapper: GameWrapper }).wrapper = wrapper;

console.log('Tic-Tac-Logic initialized!');
console.log('Features enabled:', {
  splash: true,
  preloader: true,
  pauseOnLostFocus: true,
});
console.log('Controls:');
console.log('  - Click: Cycle cell (empty → X → O → empty)');
console.log('  - Arrow keys: Move selection');
console.log('  - X/1: Place X');
console.log('  - O/2: Place O');
console.log('  - Delete/0: Clear cell');
console.log('  - H: Get hint');
